import React, { useContext, useState } from 'react'
import PageContainer from '../containers/PageContainer'
import PrimaryButton from '../buttons/PrimaryButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import HelpIcon from '@mui/icons-material/Help';
import ResponsiveModal from '../modal/ResponsiveModal';
import SendIcon from '@mui/icons-material/Send';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { postResendActivationEmail } from '../config/apiRoutes';
import useFetch from '../hooks/useFetch';
import AuthContext from '../contexts/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';

type Props = {}

const NotActivatedPage = (props: Props) => {
    const { t } = useTranslation();
    const [resendModalOpen, setResendModalOpen] = useState(false);
    const [emailResent, setEmailResent] = useState(false);
    const loader = useFetch(false);
    const { logout } = useContext(AuthContext);

    function handleInfoModalClose() {
        setResendModalOpen(false);
        setEmailResent(false);
    }

    async function handleResendEmail() {
        const response = await loader.call("POST", postResendActivationEmail);
        if (response.ok) {
            setEmailResent(true);
        }
    }

    function handleRefreshPage() {
        window.location.reload();
    }

    return (
        <>
            <PageContainer >
                <div className="flex justify-center items-center px-6 pt-10">
                    <div className="bg-secondary-pale w-full md:w-[600px] text-center py-5 px-3">
                        <div className="text-2xl font-bold text-primary-dark">
                            {t("auth.activate_account")}
                        </div>
                        <div className="italic ">
                            {t("auth.account_pending_activation")}
                        </div>
                        <div className="font-bold text-[18px] text-primary-dark py-1">
                            {t("auth.check_your_activate_email")}
                        </div>
                        <div className="mt-2">
                            <PrimaryButton
                                variant="strike"
                                startIcon={<RefreshIcon />}
                                onClick={handleRefreshPage}
                            >
                                {t("auth.refresh_page")}
                            </PrimaryButton>
                        </div>
                        <div className="mt-3">
                            <PrimaryButton
                                variant="outlined"
                                startIcon={<HelpIcon />}
                                onClick={() => setResendModalOpen(true)}
                            >
                                {t("auth.did_not_receive_activation_email")}
                            </PrimaryButton>
                        </div>
                        <div className="mt-3 italic">
                            <PrimaryButton
                                variant="outlined"
                                startIcon={<LogoutIcon />}
                                onClick={logout}
                            >
                                {t("navigation.logout")}
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </PageContainer>
            <ResponsiveModal
                open={resendModalOpen}
                handleClose={handleInfoModalClose}
                width={"500px"}
                minWidth={"300px"}
            >
                <div>
                    <div>
                        {t("auth.activate_tip")}
                    </div>
                    <div className="mt-3 text-center">
                        {!emailResent && (
                            <PrimaryButton
                                fullWidthOnMobile
                                startIcon={<SendIcon />}
                                onClick={handleResendEmail}
                            >
                                {t("auth.resend_email")}
                            </PrimaryButton>
                        )}
                        {emailResent && (
                            <div>
                                <Alert severity='info'>
                                    {t("auth.email_resent")}
                                </Alert>
                            </div>
                        )}
                    </div>
                </div>
            </ResponsiveModal>
        </>
    )
}

export default NotActivatedPage